export default __webpack_public_path__ + "static/media/icon-cart.539ec608.svg";